import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02c70db2&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/home/vsts/work/1/a/NuxtApp/components/app/Breadcrumbs.vue').default,FormForgotPassword: require('/home/vsts/work/1/a/NuxtApp/components/form/ForgotPassword.vue').default})
